import pulse from '@finn-no/pulse-sdk';
import type { PrepackageSearchState } from '../../types';
import { buildPrepackageTrackingItem } from './buildPrepackageTrackingItem';

export const trackPopularDestinationClick = (destination: string): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Filter',
        name: 'Select popular destination',
        object: {
            id: 'popular_destination_autocomplete_prepackage',
            name: destination,
            type: 'UIElement',
            elementType: 'Option',
        },
        vertical: {
            name: 'travel',
            subVertical: 'prepackage',
        },
    });
};

export const trackDestinationPickerOpened = (): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Open prepackage destination picker',
        object: {
            id: 'prepackage_destination_picker',
            type: 'UIElement',
            elementType: 'Button',
        },
        vertical: {
            name: 'travel',
            subVertical: 'prepackage',
        },
    });
};

export const trackDestinationPickerSelect = (destination: string, level: string): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Filter',
        name: 'Select prepackage destination',
        object: {
            id: 'prepackage_destination_picker',
            name: destination,
            type: 'UIElement',
            elementType: level,
        },
        vertical: {
            name: 'travel',
            subVertical: 'prepackage',
        },
    });
};

export const trackPrepackageSearchClick = (position: string, state: PrepackageSearchState): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Search',
        name: 'Search prepackage',
        object: {
            // @ts-ignore id can only be string
            id: undefined,
            type: 'UIElement',
            elementType: 'Button',
            position,
            numHits: state.totalOffers ?? 0,
            items: [buildPrepackageTrackingItem(state)],
        },
        target: {
            id: '/reise/pakkereiser',
            type: 'Listing',
        },
        vertical: {
            name: 'travel',
            subVertical: 'prepackage',
        },
    });
};
